/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const registerFromDeviceRequestRequestSchema = z
	.object({
		country_code: z.string().min(1).max(4).optional().default("+7"),
		phone: z.string().min(1).max(11),
		code: z.string().optional(),
		loyalty_program_consent: z.boolean().optional().default(true),
		first_name: z.string().min(1).optional(),
	})
	.describe("Сериализатор регистрации гостя с киоска.");
